import { useQuery } from "react-query"
import { getLanguageTemplates } from "api/languageTemplates"

export const languageTemplatesCacheKey = (eventId: string) => ["languageTemplates", eventId]

export const useLanguageTemplates = (eventId: string) => useQuery(
  languageTemplatesCacheKey(eventId),
  () => getLanguageTemplates(eventId).then(({ data }) => data.data),
  { enabled: Boolean(eventId) },
)
